import { render, staticRenderFns } from "./-HotelImage.vue?vue&type=template&id=353a1933&scoped=true&"
import script from "./-HotelImage.vue?vue&type=script&lang=ts&"
export * from "./-HotelImage.vue?vue&type=script&lang=ts&"
import style0 from "./-HotelImage.vue?vue&type=style&index=0&id=353a1933&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353a1933",
  null
  
)

export default component.exports